import { BaseApiClient } from '../BaseApiClient';
import { urls } from '../constants';
export class UserEmailPolicyApi extends BaseApiClient {
  constructor(appName) {
    super(appName);
    this.getUserEmailPolicyConfig = async () => {
      return this.get(`${urls.identity.configurations.v1}/user-emails-policy`);
    };
  }

  /** Retrieve users email policy config. */
}

export default new UserEmailPolicyApi('default');